// eslint-disable-next-line yola/import/no-webpack-loader-syntax
import HEADER_CODE_SCRIPT_CONTENT from 'raw-loader!./website-animation-header-code.js';
// eslint-disable-next-line yola/import/no-webpack-loader-syntax
import FOOTER_CODE_SCRIPT_CONTENT from 'raw-loader!./website-animation-footer-code.js';

export default {
  HEADER_CODE_SCRIPT_CONTENT,
  FOOTER_CODE_SCRIPT_CONTENT,
};
